/**
 * Action creators for managing predictions.
 *
 * The following functions provide actions to be dispatched to Redux store 
 * for increasing or decreasing the predictions based on provided data.
 */

/**
 * incPrediction creates an action to increase the prediction.
 *
 * It creates an action with a type of "INC_PREDICTION" and payload 
 * containing the data (expected to have an index indicating which prediction to increase).
 *
 * @param {Object} data - The data for the prediction increment action.
 * @param {number} data.index - The index of the prediction that needs to be increased.
 *
 * @returns {Object} - The action object with type and payload.
 */
export const incPrediction = (data) => {
  return { type: "INC_PREDICTION", payload: data}
}

/**
 * decPrediction creates an action to decrease the prediction.
 *
 * It creates an action with a type of "DEC_PREDICTION" and payload 
 * containing the data (expected to have an index indicating which prediction to decrease).
 *
 * @param {Object} data - The data for the prediction decrement action.
 * @param {number} data.index - The index of the prediction that needs to be decreased.
 *
 * @returns {Object} - The action object with type and payload.
 */
export const decPrediction = (data) => {
  return { type: "DEC_PREDICTION", payload: data}
}
